import http from '@services/http'
import {
  IClubList,
  IClubInfo,
  IClubOption,
  IUnReadClubMessageCount,
  ISimpleClubList,
  IClubNoticeList,
} from '@protocol/club'

export default {
  getSimpleClubList(data: ISimpleClubList.Params): Promise<ISimpleClubList.Schema> {
    return http.get('club/simpleList', data || {})
  },
  getClubList(data: IClubList.Params): Promise<IClubList.Schema> {
    return http.get('club/list', data || {})
  },

  getClubInfo(data: IClubInfo.Params): Promise<IClubInfo.Schema> {
    return http.post('club/info', data || {})
  },

  getSingleBetPossibleList(data: IClubList.Params): Promise<IClubList.Schema> {
    return http.post('club/singleBetPossibleList', data || {})
  },

  getClubOption(data: IClubOption.Params): Promise<IClubOption.Schema> {
    return http.post('club/option', data || {})
  },

  getUnReadClubMessageCount(data: IUnReadClubMessageCount.Params): Promise<IUnReadClubMessageCount.Schema> {
    return http.post('club/unReadClubMessageCount', data || {})
  },

  getEnabledClubLiveLicense(data) {
    return http.post('club/getEnabledClubLiveLicense', data || {})
  },

  getClubNoticeList(data: IClubNoticeList.Params): Promise<IClubNoticeList.Schema> {
    return http.get('club/noticeList', data || {})
  }
}
